import mapJson from './campaign-map.json';
import puzzlesJson from './puzzles.json';
import overlaySvg from './map-overlay.svg?raw';
import type { CampaignMap, LocationInfo, PuzzleDefinition, ProgressSave, WorldInfo } from '../types';

export const campaignMap = mapJson as CampaignMap;
export const puzzleCatalog = (puzzlesJson as { schemaVersion: number; campaignVersion: string; puzzles: PuzzleDefinition[] }).puzzles;
export const campaignVersion = (puzzlesJson as { campaignVersion: string }).campaignVersion;
export { overlaySvg };

export const getPuzzle = (levelId: number) => puzzleCatalog[levelId - 1];
export const getLocationForLevel = (levelId: number): LocationInfo => campaignMap.locations.find((location) => levelId >= location.levelStart && levelId <= location.levelEnd)!;
export const getWorldForLocation = (location: LocationInfo): WorldInfo => campaignMap.worlds.find((world) => world.id === location.worldId)!;
export const getCurrentLevelId = (completed: number[]): number | null => {
  const done = new Set(completed);
  for (let id = 1; id <= 135; id += 1) if (!done.has(id)) return id;
  return null;
};
export const getLocationProgress = (location: LocationInfo, completed: number[]) => {
  const done = new Set(completed); let count = 0;
  for (let id = location.levelStart; id <= location.levelEnd; id += 1) if (done.has(id)) count += 1;
  return count;
};
export const isLocationUnlocked = (location: LocationInfo, completed: number[]) => getLocationProgress(location, completed) === 9;
export const getUnlockedLocations = (progress: ProgressSave) => campaignMap.locations.filter((location) => isLocationUnlocked(location, progress.completedLevelIds));
export const getCharacterAsset = (location: LocationInfo, thumb = false) =>
  `/assets/characters/${thumb ? 'thumb/' : ''}${String(location.id).padStart(2, '0')}-${location.characterId}.webp`;
export const getWorldAsset = (world: WorldInfo) => `/assets/worlds/world-${String(world.id).padStart(2, '0')}-${world.slug}.webp`;
